import { capitalizeFirstLetter } from "app/pages/sales-intelligence/common-components/styles";
import styled from "styled-components";

export const StyledTimeFrameText = styled.span`
    ${capitalizeFirstLetter};

    color: currentcolor;
    white-space: nowrap;
`;
